import { defineStore } from "pinia";
import { ref, watchEffect } from "vue";

export const useDarkModeStore = defineStore("darkMode", () => {
  // 从 localStorage 读取初始状态，默认为 false (亮色)
  const isDark = ref<boolean>(localStorage.getItem("theme") === "dark");

  // 监听状态变化，同步到 localStorage
  watchEffect(() => {
    localStorage.setItem("theme", isDark.value ? "dark" : "light");
    // 可选：同时给 body 添加类名，方便自定义 CSS 覆盖
    if (isDark.value) {
      document.body.setAttribute("arco-theme", "dark");
    } else {
      document.body.removeAttribute("arco-theme");
    }
  });

  const toggleTheme = () => {
    isDark.value = !isDark.value;
  };
  // 【新增】重置主题为默认（亮色）
  const resetTheme = () => {
    isDark.value = false;
  };
  return {
    isDark,
    toggleTheme,
    resetTheme,
  };
});
